export default class DatabaseError extends Error {
  constructor() {
    super('Houve um problema no banco de dados.');
    this.name = 'DatabaseError';
  }
}
